import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';

import { ApiQuery } from '../../../../common/model/api.query';
import { ContactOutput } from '../model/contact.output';

export interface FetchContactByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchContactByIdApiQuery extends ApiQuery<
	ContactOutput,
	FetchContactByIdParams
> {
	client = 'iam';
	document = gql`
		query FetchContactById($id: UUID!) {
			fetchContactById(id: $id) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'fetchContactById';
}
